import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CORE, CORE_JOB_EDUCATIONS } from "../../../common/URLs";

export const fetchJobEducation = async () => {
    const url = `${BASE_URL}/${CORE}/${CORE_JOB_EDUCATIONS}` // Proxy path
    try {
      const token = await fetchToken()

      const response = await fetch(url, {
        method: "GET",
        headers: {
          'Accept': "application/json",
          'Authorization':
            `Bearer ${token}`,
        },
      });
    //   console.log("response", response)
      const data = await response.json();
      return data;
    }catch(error){
        // console.log("error", error)
        return error
    }
  };

// api.js
export const addJobEducation = async (newJobEducation) => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_EDUCATIONS}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        'Accept': "application/json",
        "Content-type": "application/json",

        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(newJobEducation),
    });
    const data = await response.json();
    // console.log("API Data Education", data)
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};


export const deleteJobEducation = async (uuid) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_JOB_EDUCATIONS}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting job Education: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting job Education: " + error.message);
  }
};

export const updateJobEducation = async (uuid, jobEducationData) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_JOB_EDUCATIONS}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(jobEducationData),
    });


    if (!response.ok) {
      throw new Error("Error updating job Department: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job Department: " + error.message);
  }
};